import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = (props: any) => {
  const options = {
    // indexAxis: "y" as const,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderWidth: 0,
        // borderRadius: 6,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right" as const,
        display: props.place === "REVENUE_REPORT" ? true : false,
      },
      title: {
        display:
          props.place === "TRANSACTION_REPORT" ||
            props.place === "REVENUE_REPORT"
            ? false
            : true,
        text: "Lead Source",
        align: "start" as const,
        color: "#142C44",
        font: {
          size: 14,
          weight: "500",
          family: "Poppins",
        },
      },
      tooltip: {
        enabled: true,
        mode: 'index' as const,
        intersect: false,
        callbacks: props.place === "REVENUE_REPORT" ? {
          title: function (context: any) {
            return context[0]?.label || '';
          }
        } : undefined,
      },
    },
    scales: {
      y: {
        stacked: props.place === "REVENUE_REPORT" ? true : false,
        grid: {
          display: false,
        },
        ticks: {
          display: props.place === "REVENUE_REPORT" ? false : true,
        },
      },
      x: {
        stacked: props.place === "REVENUE_REPORT" ? true : false,
        ticks: {
          stepSize: 1,
          maxRotation: props.labels?.length > 20 ? 45 : 0,
          minRotation: 0,
          callback: function (value: any, index: any, values: any) {
            if (props.place === "REVENUE_REPORT" && props.labels?.length > 60) {
              const step = Math.ceil(props.labels.length / 20);
              return index % step === 0 ? props.labels[index] : '';
            }
            return props.labels ? props.labels[index] : value;
          }
        },
      },
    },
  };
  const [chartData, setChartData] = React.useState([]);

  useEffect(() => {
    let dataArray = props.data;
    if (props.data) {
      let data: any = [];
      dataArray &&
        dataArray?.map((obj: any) => {
          const newObj = {
            label:
              props.place === "TRANSACTION_REPORT" && obj?.label === "Paid"
                ? "Successful"
                : obj.label,
            data: obj.data,
            backgroundColor:
              props.place === "TRANSACTION_REPORT"
                ? obj?.label === "Failed"
                  ? "#EC3939"
                  : "#11C89B"
                : props.place === "REVENUE_REPORT"
                  ? obj?.label === "Overdue"
                    ? "#EC3939"
                    : obj?.label === "Upcoming"
                      ? "#FFA500"
                      : obj?.label === "Pending"
                        ? "#FFD700"
                        : "#11C89B"
                  : "#11C89B",
            barThickness: props.place === "REVENUE_REPORT"
              ? (() => {
                const labelCount = props.labels?.length || 1;
                if (labelCount <= 7) return 40;
                if (labelCount <= 31) return 35;
                if (labelCount <= 90) return 25;
                return 20;
              })()
              : 15,
          };
          data.push(newObj);
          setChartData(data);
          return null;
        });
    }
  }, [props.data]);

  const labels = props.labels;

  const data = {
    labels,
    datasets: chartData,
  };
  return (
    <>
      <Bar options={options} data={data} />
    </>
  );
};

export default BarChart;
